"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AlarmingChartsContent = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _paulCorePackage = require("paul-core-package");
var _reactRedux = require("react-redux");
var _material = require("@mui/material");
var _widgets = require("../../../widgets");
var _PwhChartWrap = require("../../../components/GroupedCharts/PwhChartWrap");
var _HtgHxChartWrap = require("../../../components/GroupedCharts/HtgHxChartWrap");
var _selectors = require("../../../redux/selectors");
var _constants = require("../../../utils/constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const AlarmingChartsContent = exports.AlarmingChartsContent = /*#__PURE__*/(0, _react.memo)(_ref => {
  let {
    siteId,
    chartId,
    onClose,
    equipmentKeyIsPwh,
    equipment
  } = _ref;
  const hasData = (0, _reactRedux.useSelector)(_selectors.selectHasData);
  if (!hasData) {
    return /*#__PURE__*/_react.default.createElement(_material.Box, {
      sx: {
        margin: '0 auto',
        width: 'fit-content'
      }
    }, /*#__PURE__*/_react.default.createElement(_material.CircularProgress, {
      sx: {
        color: _constants.colors['main-color-cl-19']
      }
    }));
  }
  if (!equipment) return /*#__PURE__*/_react.default.createElement(_widgets.NotExist, {
    onClose: onClose
  });
  if (equipmentKeyIsPwh) {
    return /*#__PURE__*/_react.default.createElement(_PwhChartWrap.PwhChartWrap, {
      siteId: siteId,
      isAlarm: true,
      chartId: chartId,
      onClose: onClose
    });
  }
  return /*#__PURE__*/_react.default.createElement(_HtgHxChartWrap.HtgHxChartWrap, {
    siteId: siteId,
    isAlarm: true,
    chartId: chartId,
    onClose: onClose
  });
}, function () {
  let prev = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let next = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return prev.siteId === next.siteId && prev.chartId === next.chartId && prev.onClose === next.onClose && prev.equipmentKeyIsPwh === next.equipmentKeyIsPwh && _paulCorePackage.functions.areEqual(prev.equipment, next.equipment);
});
AlarmingChartsContent.propTypes = {
  onClose: _propTypes.default.func,
  siteId: _propTypes.default.string.isRequired,
  chartId: _propTypes.default.string.isRequired,
  equipment: _propTypes.default.shape({}),
  equipmentKeyIsPwh: _propTypes.default.bool.isRequired
};